module.exports = __webpack_public_path__ + "static/Gold-ac89523ac50c5835f190ead964a0f532.png";